// baseurl.js

// Backend API base URL
// export const baseurl = "http://localhost:5000/api/"; 
export const baseurl = "https://invoice.nexsdigital.com/api/"; 

// Image base URL (for static uploads)
// export const imgurl = "https://lightpink-chicken-279794.hostingersite.com/"; 
export const imgurl = "https://invoice.nexsdigital.com/"; 
